import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c5ws2rc6: FaireBrandEntity = {
  token: "b_c5ws2rc6",
  type: "brand",
  name: "Bourbon Barrel Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/aeecffac4c32afbf5dc7c884d3e63782f29aae2acb7b613d24441628d7bf8fa0.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/262a113258ca4c6f5fc3c52d058a6d6e1e5307bbb94ae74d802b0c9451db1df8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aeecffac4c32afbf5dc7c884d3e63782f29aae2acb7b613d24441628d7bf8fa0.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/262a113258ca4c6f5fc3c52d058a6d6e1e5307bbb94ae74d802b0c9451db1df8.jpeg",
  location: "Louisville, KY, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 77,
  isTopShop: true,
  isInsider: true,
  description:
    "All of our items are handcrafted in small batches in Louisville, Kentucky. We use reclaimed barrels straight from Kentucky’s finest bourbon distilleries as both a smoking and aging agent. The process imparts an added dimension of flavor that cannot be replicated using any other method.\n\nOur signature product, Bluegrass Soy Sauce, is the only microbrewed soy sauce made in the United States and the ONLY soy sauce in the world fermented and aged in bourbon barrels.\n\nWith the popularity of bourbon continuing to increase, Bourbon Barrel Foods has championed the idea of combining the Kentucky Bourbon Industry with the local food movement. Our “EAT YOUR BOURBON” slogan embodies this idea and has catapulted many of our products to the forefront of the culinary scene.\n\nOur product list is ever growing but currently includes Bourbon Barrel Aged sauces, vanilla extract, and sorghum, plus bourbon smoked spices, sugar, and other Kentucky-Bourbon inspired items.\n\nIn 2012, Bourbon Barrel Foods partnered with Woodford Reserve® to create a cocktail and culinary line. With the addition of the Bourbon Barrel Aged Cocktail Bitters, Bourbon Cherries and Bourbon Smoked Spice Blends, the Woodford Reserve® items expanded our reach to enthusiasts of this iconic brand.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:22.844Z",
    importedBy: "entity-db-cli",
  },
};
